'use strict';

require('normalize.css/normalize.css');

require('./index.less');


/*****************
 ** WEBPACK FOOTER
 ** ./components/style/index.js
 ** module id = 232
 ** module chunks = 0
 **/